import { FC } from 'react'
import * as S from './styles'
import { BlogSearch, PostTag, Social } from '../Components'
import { Questions } from '../Components/Questions'

export const BlogSide: FC<any> = ({ content, tags = [] }) => (
  <>
    <S.SearchSetup>
      <BlogSearch />
    </S.SearchSetup>
    <S.PostTagWrap>
      <PostTag tags={tags} />
    </S.PostTagWrap>
    <Social content={content} />
    <Questions
      email={content['email']}
      phone={content['phone']}
      contact_us_title={content['contact_us_title']}
      contact_us_description={content['contact_us_description']}
    />
  </>
)
